import { IContentManager } from '../../models/content-manager/icontent-manager';

export class ContentManager {
    public static contentExtraction(body:Array<IContentManager>, businessUnit:string, category:string): Array<IContentManager>{
        let iContentents = new Array<IContentManager>();

        body?.forEach(val=>{
            if(val.linea_negocio === businessUnit && val.category === category){
                iContentents.push(val);
            }
        });        
        return iContentents;
    }

}
